import React, { ChangeEvent } from "react";
import { Link } from "react-router-dom";

interface HeaderTableProps {
  title?: string;
  subtitle?: string;
  buttonText?: string;
  inputPlaceholder?: string;
  selectPlaceholder?: string;
  link?: string;
  loading?: boolean;
  searchTerm?: string;
  selectedValue?: any;
  linkText?: string;
  onButtonClick?: () => void;
  onSearchChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  onSelectChange?: (event: ChangeEvent<HTMLSelectElement>) => void;
  selectOptions: { value: string; label: string }[];
}

const HeaderTable: React.FC<HeaderTableProps> = ({
  title,
  subtitle,
  buttonText,
  inputPlaceholder,
  selectPlaceholder,
  loading,
  searchTerm,
  selectedValue,
  onButtonClick,
  onSearchChange,
  onSelectChange,
  selectOptions,
  link,
  linkText,
}) => {
  return (
    <div className="p-">
      <div className="hidden sm:block py-2">
        <div className="flex justify-between mb-4">
          <p
            className="mb-[10px] box-border text-[rgb(0,34,56)] block text-[20px] text-left h-[38px] font-semibold
            leading-[38.4px] ">
            {subtitle}
          </p>

          {link && (
            <Link to={link}>
              <button
                onClick={onButtonClick}
                className={` bg-gray-300 w-[150px] rounded-[10px] 
                        text-black font-semibold py-2 px-4 hover:bg-gray-400 
                        ${loading ? "opacity-50 cursor-not-allowed" : ""}`}
                disabled={loading}>
                {linkText}
              </button>
            </Link>
          )}

          {buttonText && (
            <button
              onClick={onButtonClick}
              className={` bg-gray-300 w-[150px] rounded-[10px] 
                        text-black font-semibold py-2 px-4 hover:bg-gray-400 
                        ${loading ? "opacity-50 cursor-not-allowed" : ""}`}
              disabled={loading}>
              {buttonText}
            </button>
          )}
        </div>

        <div className="flex justify-between mb-4">
          <input
            type="text"
            placeholder={inputPlaceholder}
            onChange={onSearchChange}
            value={searchTerm}
            className="border border-gray-300 p-3 rounded-md
             w-[250px]
            transition duration-200 focus:outline-none focus:ring-2 
            focus:ring-gray-200 focus:border-transparent shadow-sm 
            hover:shadow-md bg-white placeholder-gray-400"
          />

          {selectedValue && (
            <select
              onChange={(e) => {
                if (onSelectChange) {
                  onSelectChange(e);
                }
              }}
              value={selectedValue}
              className="border border-gray-300 p-3 rounded-md w-[250px]
           transition duration-200 
           focus:outline-none 
           focus:border-transparent bg-white text-gray-700">
              <option value="">{selectPlaceholder}</option>
              {selectOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          )}
        </div>
      </div>
    </div>
  );
};

export default HeaderTable;
